import React from 'react';
import { Box } from '@mui/material';
import DropdownSelect from '../../../components/DropdownSelect';

interface FilterOption {
  value: string;
  label: string;
}

interface FeeFiltersProps {
  componentType: string;
  setComponentType: (value: string) => void;
  componentTypeOptions: FilterOption[];
  particulars: string;
  setParticulars: (value: string) => void;
  particularsOptions: FilterOption[];
  academicYear: string;
  setAcademicYear: (value: string) => void;
  academicYearOptions: FilterOption[];
}

const FeeFilters: React.FC<FeeFiltersProps> = ({
  componentType,
  setComponentType,
  componentTypeOptions,
  particulars,
  setParticulars,
  particularsOptions,
  academicYear,
  setAcademicYear,
  academicYearOptions
}) => {
  return (
    <Box
      display='flex'
      justifyContent='flex-start'
      alignItems='center'
      gap='48px'
      sx={{ flexGrow: 1, mr: 6 }}
    >
      <DropdownSelect
        label='Component Type'
        placeholder='Select Component Type'
        name='componentType'
        value={componentType}
        options={componentTypeOptions}
        onChange={(e: any) => {
          setComponentType(e.target.value);
        }}
        sx={{ minWidth: 200, flexGrow: 1 }}
      />
      <DropdownSelect
        label='Particulars'
        placeholder='Select Particulars'
        name='particulars'
        value={particulars}
        options={particularsOptions}
        onChange={(e: any) => {
          setParticulars(e.target.value);
        }}
        sx={{ minWidth: 200, flexGrow: 1 }}
      />
      <DropdownSelect
        label='Academic Year'
        placeholder='Select Academic Year'
        name='academicYear'
        value={academicYear}
        options={academicYearOptions}
        onChange={(e: any) => {
          setAcademicYear(e.target.value);
        }}
        sx={{ minWidth: 200, flexGrow: 1 }}
      />
    </Box>
  );
};

export default FeeFilters;
